import { slideToggle } from '../../utils/slideToggle';
import './style.scss';

const stblToggleAccordion = () => {
    const targets = document.querySelectorAll('.stbl-faq-list--accordion .stbl-faq__q');

    targets.forEach(elem => {
        elem.addEventListener('click', () => {

            const next = elem.nextSibling;

            slideToggle(next, 300);
            elem.classList.toggle('is-open');
        })
    })
}
stblToggleAccordion();